
export const moduleTypeOption = [
    { name: "Select Type", value: "" },
    { name: "Internal", value: "Internal" },
    { name: "External", value: "External" },
    { name: "Resource", value: "Resource" },
  ];